// src/components/pages/admin-dash/AdminAccessList.jsx
import React, { useMemo, useState } from "react";
import UserTable from "./UserTable";

/**
 * "Who has elevated access" — ADMIN and SUPPORT accounts only, pulled from
 * the same users list the "All users" screen already fetches (no endpoint
 * new). Own search/filter state, independent from the "All users" screen's,
 * so switching between the two doesn't carry over a leftover search term or
 * filter. 3-POS_FASE5_ROADMAP.md item 4.9.
 */
export default function AdminAccessList({
  users = [],
  onEdit,
  onRowClick,
  onImpersonate,
  loading = false,
  onRefresh,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterStatus, setFilterStatus] = useState("");

  const elevatedUsers = useMemo(
    () => users.filter((u) => u.type === "ADMIN" || u.type === "SUPPORT"),
    [users]
  );

  return (
    <UserTable
      users={elevatedUsers}
      onEdit={onEdit}
      onRowClick={onRowClick}
      onImpersonate={onImpersonate}
      searchTerm={searchTerm} setSearchTerm={setSearchTerm}
      filterType={filterType} setFilterType={setFilterType}
      filterStatus={filterStatus} setFilterStatus={setFilterStatus}
      loading={loading}
      onRefresh={onRefresh}
    />
  );
}
